var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"register-btn safe-area-bottom-margin _fix _b-0 w-100",on:{"click":_vm.click}},[_c('h3',{staticClass:"register-btn-label"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }